import store from "@root/redux/store";

export const handleThemeMode = (mode) => {
  store.dispatch({ type: "theme/updateMode", payload: mode });
}